

<ng-container *ngIf="localeState$ | async as localeState">
  <div class="flex justify-between items-center pr-2">
    <h2 mat-dialog-title>
      {{'Language' | translate: localeState.locale | async }}
    </h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <p>{{'Your language selection will be applied throughout the application.' | translate: localeState.locale | async}}</p>

    <ng-container *ngFor="let locale of globalLocales">
      <button mat-raised-button *ngIf="localeAvailable(locale.code)" style="margin-right: 0.5em; border: 1px solid #ddd;"
              [disabled]="locale === locale.code" (click)="setLocale(localeState, locale.code)">
        {{locale.name}}
      </button>
    </ng-container>
  </div>
</ng-container>
